import { type PreferenceUpdate } from '@dhl/receiver-preference-api'
import { useSubmitPreference } from '../../hooks/useSubmitPreference.js'
import { useUpdateAgreedPlacePhoto } from '../../hooks/useUpdateAgreedPlacePhoto.js'
import { useGetAgreedPlacePreference } from '../../hooks/useGetAgreedPlacePreference.js'
import { type ToDoorPreferenceFormValues } from '../components/ToDoorPreferenceForm.js'

export type SubmitToDoorPreferenceResult = { status: 'success' } | { status: 'partial'; error: 'photoUpload' }

export const useSubmitToDoorPreference = (
  addressId: string
): {
  submitToDoorPreference: (values: ToDoorPreferenceFormValues) => Promise<SubmitToDoorPreferenceResult>
} => {
  const { initialFormValues } = useGetAgreedPlacePreference(addressId)
  const { submitPreference } = useSubmitPreference()
  const { updateAgreedPlacePhoto } = useUpdateAgreedPlacePhoto()

  const submitToDoorPreference = async (values: ToDoorPreferenceFormValues): Promise<SubmitToDoorPreferenceResult> => {
    let body: PreferenceUpdate = {
      preferenceType: 'DoorDelivery',
      fallback: {
        preferenceType: 'NoPreference',
      },
    }

    if (values.fallback === 'AgreedPlaceDelivery') {
      body = {
        ...body,
        fallback: {
          description: values.description,
          preferenceType: 'AgreedPlaceDelivery',
        },
      }
    }

    await submitPreference(addressId, body)

    try {
      await updateAgreedPlacePhoto(addressId, {
        photo: values.agreedPlacePhoto,
        previousPhoto: initialFormValues?.agreedPlacePhoto,
      })
    } catch {
      return { status: 'partial', error: 'photoUpload' }
    }

    return { status: 'success' }
  }

  return { submitToDoorPreference }
}
